import styled from "styled-components";
import Colors from "../../../themes/Colors";

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  width: 100%;
`;

export const HorizontalCard = styled.div`
  background: ${Colors.white};
  border: 3px solid ${Colors.primaryHumano};
  border-radius: 8px;
  padding: 20px;
  overflow: hidden;
  max-width: 1200px;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid ${Colors.primaryHumano};
`;

export const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  background: ${Colors.primaryHumano};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: ${Colors.white};
`;

export const CardTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${Colors.primaryHumano};
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  width: 100%;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const InfoCard = styled.div`
  background: ${Colors.white};
  border: 1px solid ${Colors.lineColor};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px ${Colors.GRAY_80};
  min-height: 250px;
  overflow: hidden;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldLabel = styled.label`
  font-weight: 500;
  color: ${Colors.darkGrayLabels};
  font-size: 16px;
  margin-bottom: 4px;
`;

export const FieldValue = styled.div`
  background: ${Colors.greyLight};
  border: 1px solid ${Colors.grey};
  border-radius: 4px;
  padding: 12px;
  color: ${Colors.txt};
  font-size: 16px;
  min-height: 20px;
  display: flex;
  align-items: center;
  word-break: break-word;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${Colors.greyLight};
  word-wrap: break-word;
  overflow-wrap: break-word;
  flex: 1;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 500;
  color: ${Colors.darkGrayLabels};
  min-width: 120px;
  flex-shrink: 0;
  margin-right: 16px;
`;

export const InfoValue = styled.span`
  color: ${Colors.txt};
  text-align: right;
  flex: 1;
  word-break: break-word;
  max-width: 60%;
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 50px;
`;

export const LoadingText = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: ${Colors.darkGrayLabels};
`;

export const NotFoundContainer = styled.div`
  text-align: center;
  padding: 50px;
`;

export const NotFoundTitle = styled.h2`
  color: ${Colors.txt};
  margin-bottom: 16px;
`;

export const NotFoundText = styled.p`
  color: ${Colors.darkGrayLabels};
  margin-bottom: 24px;
`;

export const EmailLink = styled.a`
  color: ${Colors.primaryHumano};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ContainerWrapper = styled.div`
  max-width: 1000px;
  width: calc(90vw - 80px);
  margin: 0 auto;
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
